import React from 'react';
import { Grid } from '@mui/material';

function MatrixDriverVendor(props) {
  const { matrix } = props;
  // Get the current URL pathname
  const currentPathname = window.location.pathname;
  const pathnameParts = currentPathname.split('/');
  const lastName = pathnameParts[pathnameParts.length - 1];
  const desiredLastName = 'detail';
  // Check if the last name matches the desired last name
  const isDesiredLastName = lastName === desiredLastName;
  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        columnGap={2}
        className={isDesiredLastName ? 'displayNone' : 'displayBlock'}
      >
        <Grid item>
          <h1 className="font16 fw700">Monthly Matrix</h1>
        </Grid>
      </Grid>

      <Grid
        container
        direction="row"
        justifyContent="start"
        alignItems="center"
        className="matrixAlign"
        rowSpacing={2}
      >
        {matrix &&
          matrix.map((document) => (
            <Grid
              item
              container
              spacing={2}
              md={3.5}
              sm={4.7}
              xs={12}
              className="alignStart flexRow boxShadow"
              key={document.id}
            >
              <Grid item>
                <img src={document.icon} alt="wallet" />
              </Grid>
              <Grid item className="cardAlign">
                <p className="marginBlock10 font28 colorPrimary fw500">
                  {document.amt}
                </p>
                <p className="marginBlock10 font20 colorBlack fw500">
                  {' '}
                  {document.name}
                </p>
              </Grid>
            </Grid>
          ))}
      </Grid>
    </div>
  );
}

export default MatrixDriverVendor;
